export default {
  WAITING_WALLET: 'waiting_wallet',
  PENDING_APPROVAL: 'pending_approval',
  REVOKED: 'revoke',
  APPROVED: 'active',
  ACTIVE: 'activeA',
  PENDING: 'pending',
};
